// Backend routes that are genuinely public (no merchant/customer token required).
// The request interceptor in configs/axiosConfig.js must not attach Authorization
// to these — sending a token to a public storefront endpoint defeats caching and
// leaks session state to routes that don't need it.
const PUBLIC_API_PATTERNS = [
  /\/customer\/api\/mobile-check\/?$/,
  /\/customer\/api\/create-user\/?$/,
  /\/customer\/api\/verify-loginOtp\/?$/,
  /\/customer\/api\/product-search\/?$/,
  /\/customer\/api\/selected-product-search\/?$/,
  /\/customer\/products\/\d+\/?$/,
  /\/customer\/api\/categories\/?$/,
  /\/customer\/api\/website-info\/?$/,
  /\/customer\/store-status\/?$/,
  /\/customer\/api\/about\/?$/,
  /\/customer\/api\/terms-&-condition\/?$/,
  /\/customer\/api\/contact-us\/?$/,
  /\/customer\/api\/featured-products\/?$/,
  /\/customer\/api\/top-collection-products\/?$/,
  /\/customer\/get-special-sale\/?$/,
  /\/customer\/get-shp-images\/?$/,
  /\/customer\/get-prom-text-content\/?$/,
  /\/customer\/get-privacy-policy-content\/?$/,
  /\/product\/report-product\/?$/,
  /\/sso_d6\/d6sso-signin\/?$/,
];

export const isPublicApiPath = (url = "") => PUBLIC_API_PATTERNS.some((re) => re.test(url));
